import {
  FETCH_REMINDERS_START,
  FETCH_REMINDERS_SUCCESS,
  ADD_REMINDER_START,
  ADD_REMINDER_SUCCESS,
  EDIT_REMINDER_START,
  EDIT_REMINDER_SUCCESS,
  DELETE_REMINDER_START,
  DELETE_REMINDER_SUCCESS,
  REMINDERS_API_ERROR,
  CLEAR_REMINDERS_MODAL,
} from "./actionTypes";

// test comment
export const fetchRemindersStart = (payload) => ({
  type: FETCH_REMINDERS_START,
  payload,
});

export const fetchRemindersSuccess = (data) => ({
  type: FETCH_REMINDERS_SUCCESS,
  payload: data,
});

export const addReminderStart = (payload) => ({
  type: ADD_REMINDER_START,
  payload,
});

export const addReminderSuccess = (data) => ({
  type: ADD_REMINDER_SUCCESS,
  payload: data,
});

export const editReminderStart = (payload) => ({
  type: EDIT_REMINDER_START,
  payload,
});

export const editReminderSuccess = (data) => ({
  type: EDIT_REMINDER_SUCCESS,
  payload: data,
});

export const deleteReminderStart = (payload) => ({
  type: DELETE_REMINDER_START,
  payload,
});

export const deleteReminderSuccess = (data) => ({
  type: DELETE_REMINDER_SUCCESS,
  payload: data,
});

export const remindersApiError = (error) => ({
  type: REMINDERS_API_ERROR,
  payload: error,
});

export const clearRemindersModal = () => ({
  type: CLEAR_REMINDERS_MODAL,
});
